<div class="header_hero-bg"></div>

<div class="mega-trade-container container-fluid">
  <div class="mega_body-content">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
      <div class="row">
        <div class="col-12- col-sm-12 col-md-12 col-lg-12">
          <ng-container
            *ngIf="
              hasFileExtensionError ||
              isFileCorrupted ||
              isFileEmpty ||
              hasValidationErrors ||
              isFilePasswordProcted ||
              hasFileLevelErrors
            "
          >
            <div class="row error-banner-container">
              <div class="col-1 col-sm-1 col-md-1 col-lg-1">
                <div class="status-icon float-end">
                  <img alt="" src="assets/images/icon_error_white.svg" />
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-9 col-lg-9">
                <p class="file-format-text" id="banner-error-msg">{{ showBannerErrorMsg }}</p>
              </div>
              <div class="col-1 col-sm-1 col-md-2 col-lg-2">
                <div class="exit-button float-end" (click)="closeMessageBanner()">
                  <img src="assets/images/x_white.svg" />
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="showCollateralUploadSucessMessage">
            <div
              class="row file-format-container file-format-cancel-banner-container growl-success"
            >
              <div class="col-2 col-sm-2 col-md-2 col-lg-2">
                <div class="status-icon float-end">
                  <span><i class="fa fa-check-circle-o cancel-banner-checkmark"></i></span>
                </div>
              </div>
              <div class="col-8 col-sm-8 col-md-8 col-lg-8">
                <p class="file-format-header">{{ displaySucessHeader }}</p>
                <p class="file-format-text">{{ displaySucessMessage }}</p>
              </div>
              <div class="col-2 col-sm-2 col-md-2 col-lg-2">
                <div class="exit-button float-end" (click)="closeSuccessMessageBanner()">
                  <img src="assets/images/x_white.svg" />
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="showDeleteAllSucessMessage">
            <div
              class="row file-format-container file-format-cancel-banner-container growl-success"
            >
              <div class="col-2 col-sm-2 col-md-2 col-lg-2">
                <div class="status-icon float-end">
                  <span><i class="fa fa-check-circle-o cancel-banner-checkmark"></i></span>
                </div>
              </div>
              <div class="col-8 col-sm-8 col-md-8 col-lg-8">
                <p class="file-format-header">{{ displayDeleteAllSucessHeader }}</p>
                <p class="file-format-text">{{ displayDeleteAllSucessMessage }}</p>
              </div>
              <div class="col-2 col-sm-2 col-md-2 col-lg-2">
                <div class="exit-button float-end" (click)="closeSuccessMessageBanner()">
                  <img src="assets/images/x_white.svg" />
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div
            class="mega_header-information__sub-header analyzer-align"
            id="collateral-analyzer-title"
          >
            Collateral Analyzer
          </div>
        </div>
      </div>
      <div *ngIf="!showInitialScreen">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
            <div class="line-break"></div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0" id="uploaded-filename-text">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 analyzer-align">
              <span class="collateral-file-info text-size">Collateral File: </span>
              <span class="text-size">{{ fileName }}</span>
              <a class="replace-file-link pl-8" (click)="handleReplaceFileShowMessage()"
                >(replace)</a
              >
              <span class="selected-tab-seperate"> | </span>
              <span class="collateral-file-info text-size">Selected tab: </span>
              <span id="select-change-tab-value" class="text-size">{{ tabName }}</span>
              <a class="replace-file-link pl-8" (click)="handleChangeTab()" id="handle-change-tab"
                >(change)</a
              >
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
            <div class="line-break"></div>
          </div>
          <div class="row col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
            <div class="col-12 col-sm-12 col-md-2 col-lg-2 pl-0">
              <div class="pool-details-pb-15">
                <span id="prefix-label" class="text-size">Prefix</span><br />
                <span class="fw-bold-and-size" id="pool-prefix">{{
                  megaDetailsList?.megaPrefix ? megaDetailsList?.megaPrefix : ''
                }}</span>
              </div>
              <div>
                <span id="pool-amount-label" class="text-size">Pool Amount</span><br />
                <span class="fw-bold-and-size" id="pool-amount">{{
                  megaDetailsList?.dealAmount | currency: 'USD' : 'symbol' : '1.2-2'
                }}</span>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-2 col-lg-2 pl-0">
              <div class="pool-details-pb-15">
                <span id="issue-date-label" class="text-size">Issue Date</span><br />
                <span class="fw-bold-and-size" id="pool-issue-date">{{
                  megaDetailsList?.megaIssueDate | date: 'MM/dd/yyyy'
                }}</span>
              </div>
              <div>
                <span id="fnma-issued-label" class="text-size">FNMA Issued (%)</span><br />
                <span class="fw-bold-and-size" id="pool-fnma-issued"
                  >{{ fannieIssued ? (fannieIssued | number: '1.0-2') : 0 }}%</span
                >
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-2 col-lg-2 pl-0">
              <div class="pool-details-pb-15">
                <span id="maturity-date-label" class="text-size">Maturity Date</span><br />
                <span class="fw-bold-and-size" id="pool-maturity-date">{{
                  megaDetailsList?.maturityDate | date: 'MM/yyyy'
                }}</span>
              </div>
              <div>
                <span id="fhlmc-issued-label" class="text-size">FHLMC Issued (%)</span><br />
                <span class="fw-bold-and-size" id="pool-fhlmc-issued"
                  >{{ freddieIssued ? (freddieIssued | number: '1.0-2') : 0 }}%</span
                >
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-2 col-lg-2 pl-0">
              <div class="pool-details-pb-15">
                <span id="wanet-interest-rate-label" class="text-size">WA Net Interest Rate</span
                ><br />
                <span class="fw-bold-and-size" id="pool-wa-net-inte-rate">{{
                  megaDetailsList?.coupon | number: '1.3-3'
                }}</span>
              </div>
              <div>
                <span id="wa-months-maturitydate-label" class="text-size"
                  >WA Months to Maturity</span
                ><br />
                <span class="fw-bold-and-size" id="pool-wa-months-maturity-date">{{
                  megaDetailsList?.monthsToMaturity ? megaDetailsList?.monthsToMaturity : ''
                }}</span>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-2 col-lg-2 pl-0">
              <ng-container
                *ngIf="
                  collateralValidatedPoolListRes.megaType === 'SFARMMEGA' ||
                  collateralValidatedPoolListRes.megaType === 'MFARMMEGA'
                "
              >
                <div class="pool-details-pb-15">
                  <span id="subtype-label" class="text-size">Subtype</span><br />
                  <span class="fw-bold-and-size" id="pool-subtype">{{
                    megaDetailsList?.subType ? megaDetailsList?.subType : ''
                  }}</span>
                </div>
              </ng-container>
              <div class="pool-details-pb-15">
                <ng-container *ngIf="collateralValidatedPoolListRes.megaType === 'MFFIXMEGA'">
                  <div>
                    <span id="high-coupon-label" class="text-size">High Coupon</span><br />
                    <span class="fw-bold-and-size" id="pool-highCoupon">{{
                      megaDetailsList?.mfHighCoupon | number: '1.3-3'
                    }}</span>
                  </div>
                </ng-container>
              </div>
              <ng-container *ngIf="collateralValidatedPoolListRes.megaType === 'MFFIXMEGA'">
                <div>
                  <span id="low-coupon-label" class="text-size">Low Coupon</span><br />
                  <span class="fw-bold-and-size" id="pool-low-coupon">{{
                    megaDetailsList?.mfLowCoupon | number: '1.3-3'
                  }}</span>
                </div>
              </ng-container>
            </div>
            <div
              class="col-md-2 col-lg-2 col-12 col-sm-12 pl-0"
              *ngIf="!collateralValidatedPoolListRes.enableCreateMega"
            >
              <button
                class="tooltip-create-mega disable-button"
                data-bs-toggle="tooltip"
                title="{{ createMegaTitle }}"
              >
                Create Mega/Supers
              </button>
            </div>
            <div
              class="col-md-2 col-lg-2 col-12 col-sm-12 pl-0"
              *ngIf="collateralValidatedPoolListRes.enableCreateMega"
            >
              <button
                class="button fm-primary-button tooltip-create-mega"
                id="mega-supers-button"
                (click)="showCreateMegaDetailsPopup(collateralValidatedPoolListRes.megaType)"
              >
                Create Mega/Supers
              </button>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
            <div class="line-break"></div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 view-edit-collateral-header">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 view-edit-collateral-tab">
                <div class="row">
                  <div
                    class="col-2 col-sm-2 col-md-2 col-lg-2 view-edit-collateral-text"
                    (click)="showDetailsSection('collateral')"
                  >
                    <span
                      class="analyzer-grid-selection"
                      [ngClass]="{ 'selected-collateral-type-font': showAnalyzerGrid }"
                    >
                      Collateral</span
                    >
                    <div
                      class="line-break-tab"
                      [ngClass]="{ 'selected-collateral-type-border': showAnalyzerGrid }"
                    ></div>
                  </div>
                  <div
                    class="col-2 col-sm-2 col-md-2 col-lg-2 view-edit-collateral-text"
                    (click)="showDetailsSection('details')"
                    *ngIf="LDshowDisclosureDetails"
                  >
                    <span
                      class="analyzer-grid-selection"
                      [ngClass]="{ 'selected-collateral-type-font': showAnalyzerDetails }"
                      >Details</span
                    >
                    <div
                      class="line-break-tab"
                      [ngClass]="{ 'selected-collateral-type-border': showAnalyzerDetails }"
                    ></div>
                  </div>
                  <div
                    class="col-3 col-sm-3 col-md-3 col-lg-3 view-edit-collateral-text"
                    (click)="showDetailsSection('statistics')"
                    *ngIf="LDshowDisclosureDetails"
                  >
                    <span
                      class="analyzer-grid-selection"
                      [ngClass]="{ 'selected-collateral-type-font': showAnalyzerStatistics }"
                      >Statistics</span
                    >
                    <div
                      class="line-break-tab"
                      [ngClass]="{ 'selected-collateral-type-border': showAnalyzerStatistics }"
                    ></div>
                  </div>
                  <div
                    class="visible-md-5 col-12 col-sm-12 col-md-5 col-lg-5 pr-0"
                    [ngClass]="{ pdfButtonAlign: !LDshowDisclosureDetails }"
                  >
                    <div class="pdf-excel float-end">
                      <button
                        class="button fm-secondary-button button-margin-right-pdf"
                        [disabled]="!enablePDFButton"
                        (click)="generatePdf()"
                        id="pdf-button"
                      >
                        PDF
                      </button>
                      <!--button class="button fm-secondary-button" (click)="generateExcel()" id="excel-button">EXCEL
                      </button-->
                    </div>
                  </div>
                </div>
                <!-- <div class="visible-xs-12 hidden-md hidden-lg col-12 pl-0 pr-0"
                     [ngClass]="{'pdfButtonAlign': !LDshowDisclosureDetails}">
                  <button class="button fm-secondary-button button-margin-right-pdf col-12" (click)="generatePdf()"
                          [disabled]="!enablePDFButton"
                          id="pdf-button-sm">PDF
                  </button>
                  <button class="button fm-secondary-button col-12" (click)="generateExcel()" id="excel-button-sm">
                    EXCEL
                </button>
                </div> -->
              </div>
            </div>
            <div class="line-break-tab-grid collatereal-analyzer-border"></div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 mt-20" *ngIf="showAnalyzerGrid">
            <div class="visible-md-12 col-12 col-sm-12 col-lg-12 pr-0 pl-0">
              <div
                class="visible-md-12 col-12 col-sm-12 col-lg-12 pr-0 mt-10 d-flex justify-content-end"
              >
                <span>
                  <span class="collateral-file-info" id="collateral-pool-count-label-hide"
                    >Collateral Pool Count:
                  </span>
                  <span id="collateral-pool-count-hide">{{ validatedCollateralPoolCount }}</span>
                </span>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 mt-10" *ngIf="showAnalyzerGrid">
            <invd-collateral-analyzer-table
              [collateralValidatedPoolList]="collateralValidatedPoolList"
              id="collateral-table"
              (displayEditCollateralPopup)="displayEditCollateralPopup($event)"
              (deleteSelectedRows)="handleDeleteSelectedRows($event)"
              (deleteAllRows)="handleDeleteAllRows($event)"
            >
            </invd-collateral-analyzer-table>
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 mt-10" *ngIf="showAnalyzerDetails">
            <ng-container *ngIf="analyzerDetailsTabError">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <div class="status-icon disclosure-error-icon">
                  <i
                    class="fa fa-exclamation-triangle warning-exclamation-icon details-error-size"
                    id="warning-icon-details"
                  ></i>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <p class="disclosure-error-text">{{ analyzerDisclosureErrorMsg }}</p>
                <p class="disclosure-error-sub-text">We apologize for the inconvenience.</p>
              </div>
            </ng-container>
            <ng-container *ngIf="!analyzerDetailsTabError">
              <invd-collateral-analyzer-details
                [disclosureWaDetailsRes]="disclosureWaDetailsRes"
                [disclosureSellerDetailsRes]="disclosureSellerDetailsRes"
                [WAMonthsToMaturity]="WAMonthsToMaturity"
                [netInterestRate]="netInterestRate"
              >
              </invd-collateral-analyzer-details>
            </ng-container>
          </div>

          <div
            class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 mt-10"
            *ngIf="showAnalyzerStatistics"
          >
            <ng-container *ngIf="analyzerStatisticsTabError">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <div class="status-icon disclosure-error-icon">
                  <i
                    class="fa fa-exclamation-triangle warning-exclamation-icon details-error-size"
                    id="warning-icon-statistics"
                  ></i>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <p class="disclosure-error-text">{{ analyzerDisclosureErrorMsg }}</p>
                <p class="disclosure-error-sub-text">We apologize for the inconvenience.</p>
              </div>
            </ng-container>

            <ng-container *ngIf="!analyzerStatisticsTabError">
              <invd-collateral-analyzer-statistics
                [loanPurposeRes]="loanPurposeRes"
                [propertyTypeRes]="propertyTypeRes"
                [channelRes]="channelRes"
                [occupancyStatusRes]="occupancyStatusRes"
                [numberOfUnitsRes]="numberOfUnitsRes"
                [originationYearRes]="originationYearRes"
                [stateRes]="stateRes"
                [servicersRes]="servicersRes"
                [borrowersRes]="borrowersRes"
                [mortgageInsCancelIndRes]="mortgageInsCancelIndRes"
                [mortgageInsCoverageRes]="mortgageInsCoverageRes"
                [mortgageLoanAmountQuartileRes]="mortgageLoanAmountQuartileRes"
                [interestRateQuartileRes]="interestRateQuartileRes"
                [netInterestRateCurrentQuartileRes]="netInterestRateCurrentQuartileRes"
                [loanTermQuartileRes]="loanTermQuartileRes"
                [loanAgeQuartileRes]="loanAgeQuartileRes"
                [loanToValueQuartileRes]="loanToValueQuartileRes"
                [combinedLoanToValueQuartileRes]="combinedLoanToValueQuartileRes"
                [borrowerCreditScoreQuartileRes]="borrowerCreditScoreQuartileRes"
                [remainingMonthsToMaturityQuartileRes]="remainingMonthsToMaturityQuartileRes"
              >
              </invd-collateral-analyzer-statistics>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="initial-screen" *ngIf="showInitialScreen">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
          <div class="line-break"></div>
        </div>
        <div class="row">
          <div class="col-4 col-sm-4 col-md-4 col-lg-4">
            <div class="">
              <img
                alt="analyzer-intro"
                src="assets/images/Analyzer_intro_image.svg"
                class="analyzer-intro-logo"
              />
            </div>
          </div>
          <div class="col-5 col-sm-5 col-md-5 col-lg-5 visible-md-5">
            <p id="analyzer-intro-disclosure-text">{{ analyzerIntroDisclosureText }}</p>
            <p id="analyzer-intro-factors-text">{{ analyzerIntroFactorsText }}</p>
            <div class="col-md-12 col-lg-12 upload-collateral-button-margin">
              <invd-fm-xlsx-json
                *ngIf="checkFactorDataAvailable"
                [showJson]="false"
                [stringFormat]="true"
                [displayLabel]="''"
                [successMsg]="false"
                buttonLabel="Upload Collateral"
                (conversion)="onConversion($event)"
                (showFileName)="showFileName($event)"
                (showFileExtensionError)="showFileExtensionError($event)"
                (sheetsNameWithColumnCount)="sheetsNameWithColumnCount($event)"
                (getExcelSheetsContent)="getExcelSheetsContent($event)"
                (showIsFileCorrupted)="showIsFileCorrupted($event)"
              >
              </invd-fm-xlsx-json>
              <button
                class="button fm-primary-button check-factor-data"
                [disabled]="true"
                *ngIf="!checkFactorDataAvailable"
              >
                Upload Collateral
              </button>
            </div>
            <p class="analyzer-intro-asterisk-text" id="create-megas-supers-asterisk-text">
              {{ analyzerIntroAsteriskText }}
            </p>
          </div>
        </div>
        <div class="visible-xs-12 hidden-md hidden-lg col-12 mt-30">
          <p id="analyzer-intro-disclosure-text-sm">{{ analyzerIntroDisclosureText }}</p>
          <p id="analyzer-intro-factors-text-sm">{{ analyzerIntroFactorsText }}</p>
          <div class="col-md-12 col-lg-12 upload-collateral-button-margin">
            <invd-fm-xlsx-json
              *ngIf="checkFactorDataAvailable"
              [showJson]="false"
              [stringFormat]="true"
              [displayLabel]="''"
              [successMsg]="false"
              buttonLabel="Upload Collateral"
              (conversion)="onConversion($event)"
              (showFileName)="showFileName($event)"
              (showFileExtensionError)="showFileExtensionError($event)"
              (getExcelSheetsContent)="getExcelSheetsContent($event)"
              (sheetsNameWithColumnCount)="sheetsNameWithColumnCount($event)"
              (showIsFileCorrupted)="showIsFileCorrupted($event)"
            >
            </invd-fm-xlsx-json>
            <button
              class="button fm-primary-button check-factor-data"
              [disabled]="true"
              *ngIf="!checkFactorDataAvailable"
            >
              Upload Collateral
            </button>
          </div>
          <p class="analyzer-intro-asterisk-text-sm" id="create-megas-supers-asterisk-text-sm">
            {{ analyzerIntroAsteriskText }}
          </p>
        </div>

        <!-- display collatreal analyzer error messages-->
        <ng-container *ngIf="hasValidationErrors || hasFileLevelErrors">
          <invd-collateral-analyzer-error-container
            [genericErrorMesasgesList]="genericErrorMesasgesList"
            [collateralValidatedPoolListRes]="collateralValidatedPoolListRes"
            [validationErrorList]="validationErrorList"
            [compositeErrorList]="compositeErrorList"
            [fileName]="fileName"
            [hasValidationErrors]="hasValidationErrors"
          >
          </invd-collateral-analyzer-error-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="displayFileDataSelectionPopup">
  <div class="enter-mega-model-window">
    <div class="panel panel-default fadeInUpBig">
      <div class="row gx-0">
        <div class="col-sm-9 col-9 col-md-9 col-lg-9" id="collateral-file-upload-header">
          <h2 class="file-data-location" *ngIf="!changeTabClicked">Collateral Data Location</h2>
          <h2 class="file-data-location" *ngIf="changeTabClicked">Change Collateral Location</h2>
        </div>
        <div class="col-sm-3 col-3 col-md-3 col-lg-3 d-flex justify-content-end">
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="hideFileDataSelectionPopup()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-popup">
        <div class="line-break"></div>
      </div>
      <div class="panel-body mega-cancel-confirmation-model">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12">
            <p id="uploaded-file-name" class="fw-bold">Uploaded file: {{ fileName }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-20">
            <p *ngIf="!changeTabClicked">
              To continue, please tell us the location of the collateral data you'd like analyzed.
            </p>
            <p *ngIf="changeTabClicked" id="change-collateral-warning-msg">
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>By making any
              changes below, the current data on the page will be replaced.
            </p>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 mega-type mt-20">
          <span class="text-size">Tab Name</span>
          <div
            class="dropdown dropdown-menu-tab-name-width"
            id="tab-drop-down-menu"
            (mouseleave)="closeSheetDropdown()"
          >
            <button
              class="btn btn-secondary dropdown-toggle truncate-text mega-type-dropdown"
              [disabled]=""
              type="button"
              (click)="toggleSheetDropdown()"
              [attr.aria-expanded]="isSheetDropdownOpen"
            >
              {{ selectedSheet ? selectedSheet : sheetsPalceholder }}
              <span class="fa fa-chevron-down mega-dropdown-caret"></span>
            </button>
            <ul
              class="dropdown-menu ul-mega-type drop-down-height"
              [ngClass]="{ show: isSheetDropdownOpen }"
            >
              <li *ngFor="let sheet of sheets; let cusipIndex = index; trackBy: trackByIdentity">
                <button
                  type="button"
                  class="dropdown-item"
                  (click)="handleSelectedSheet(sheet, cusipIndex)"
                >
                  {{ sheet }}
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 mt-25 text-size">
          <invd-fm-checkbox
            [binary]="true"
            label="This file contains a header row"
            [(ngModel)]="hasHeaderRow"
            (onChange)="handleHeaderRowSelection($event)"
          ></invd-fm-checkbox>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 mega-type mt-20">
          <span class="text-size">CUSIP column</span>
          <div
            class="dropdown dropdown-menu-width"
            id="cusip-drop-down-menu"
            (mouseleave)="closeCusipDropdown()"
          >
            <button
              class="btn btn-secondary dropdown-toggle truncate-text mega-type-dropdown"
              [disabled]=""
              type="button"
              id="dropdownMenuSelectCusip"
              (click)="toggleCusipDropdown()"
              [attr.aria-expanded]="isCusipDropdownOpen"
            >
              {{ selectedCusip ? selectedCusip : cusipPlaceholder }}
              <span class="fa fa-chevron-down mega-dropdown-caret"></span>
            </button>
            <ul
              class="dropdown-menu ul-mega-type drop-down-height"
              [ngClass]="{ show: isCusipDropdownOpen }"
            >
              <li
                *ngFor="
                  let cusipItem of dropDownMenuItems;
                  let cusipIndex = index;
                  trackBy: trackByIdentity
                "
              >
                <button
                  type="button"
                  class="dropdown-item"
                  (click)="handleDropdownSelectionCusip(cusipItem, cusipIndex)"
                >
                  {{ cusipItem }}
                </button>
              </li>
            </ul>
          </div>
          <ng-container *ngIf="showDropDownError">
            <span class="pr-mega-error">
              <i
                class="fa fa-exclamation-circle tooltip-error icon-disable error-red dropdown-error"
              >
              </i
            ></span>
            <span class="validate-pool-status error-red"
              >The CUSIP and Original Face columns cannot have the same value</span
            >
          </ng-container>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega-type pl-0 mt-20">
          <span class="text-size">Original Face column</span>
          <div
            class="dropdown dropdown-menu-width"
            id="oface-drop-down-menu"
            (mouseleave)="closeOfaceDropdown()"
          >
            <button
              class="btn btn-secondary dropdown-toggle truncate-text mega-type-dropdown"
              [disabled]=""
              type="button"
              id="dropdownMenuSelectOface"
              (click)="toggleOfaceDropdown()"
              [attr.aria-expanded]="isOfaceDropdownOpen"
            >
              {{ selectedOface ? selectedOface : ofacePlaceholder }}
              <span class="fa fa-chevron-down mega-dropdown-caret"></span>
            </button>
            <ul
              class="dropdown-menu ul-mega-type drop-down-height"
              [ngClass]="{ show: isOfaceDropdownOpen }"
            >
              <li
                *ngFor="
                  let ofaceItem of dropDownMenuItems;
                  let ofaceIndex = index;
                  trackBy: trackByIdentity
                "
              >
                <button
                  type="button"
                  class="dropdown-item"
                  (click)="handleDropdownSelectionOface(ofaceItem, ofaceIndex)"
                >
                  {{ ofaceItem }}
                </button>
              </li>
            </ul>
          </div>
          <ng-container *ngIf="showDropDownError">
            <span class="pr-mega-error">
              <i
                class="fa fa-exclamation-circle tooltip-error icon-disable error-red dropdown-error"
              >
              </i
            ></span>
            <span class="error-red"
              >The CUSIP and Original Face columns cannot have the same value</span
            >
          </ng-container>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 remember-selections-block">
        <div class="popup-footer d-flex justify-content-end">
          <button
            class="button fm-tertiary-button"
            (click)="hideFileDataSelectionPopup()"
            id="cancel-upload-button"
            *ngIf="!changeTabClicked"
          >
            Cancel Upload
          </button>
          <button
            class="button fm-tertiary-button change-tab-cancel-button"
            (click)="hideFileDataSelectionPopup()"
            id="cancel-upload-button-cT"
            *ngIf="changeTabClicked"
          >
            Cancel
          </button>
          <button
            class="button fm-primary-button"
            (click)="validateCollateral()"
            id="submit-button"
            [disabled]="showDropDownError"
            *ngIf="!changeTabClicked"
          >
            Submit
          </button>
          <button
            class="button fm-primary-button"
            (click)="validateCollateral()"
            id="submit-button-cT-cancel"
            [disabled]="showDropDownError"
            *ngIf="changeTabClicked"
          >
            Change
          </button>
        </div>
      </div>
      <!--div class="visible-xs-12 hidden-md hidden-lg  col-12 col-sm-12 pl-0 remember-selections-block-sm-screen">
        <div class="popup-footer">
          <div class="col-5 col-sm-5 col-md-5 col-lg-5 mt-10">
          </div>
          <div class="col-7 col-sm-7 col-md-7 col-lg-7 pl-0 pr-0">
            <button class="button fm-tertiary-button" (click)="hideFileDataSelectionPopup()" id="cancel-upload-sm">
              Cancel Upload
            </button>
            <button class="button fm-tertiary-button change-tab-cancel-button" (click)="hideFileDataSelectionPopup()"
                    id="cancel-upload-sm-">
              Cancel
            </button>
            <button class="button fm-primary-button" (click)="validateCollateral()" id="submit-sm"
                    [disabled]="showDropDownError" *ngIf="!changeTabClicked">Submit
            </button>
            <button class="button fm-primary-button" (click)="validateCollateral()" id="submit-sm-cT-change"
                    [disabled]="showDropDownError" *ngIf="changeTabClicked">Change
            </button>
          </div>
        </div>
      </div-->
    </div>
  </div>
</ng-container>

<ng-container *ngIf="showEditCollateralPopup">
  <div id="collateral-edit-popup" class="enter-mega-model-window">
    <div class="panel panel-default fadeInUpBig panel-height-add-edit-modal">
      <div class="row gx-0">
        <div class="col-sm-6 col-6 col-md-6 col-lg-6">
          <h2 id="collateral-edit-model-title-msg" class="file-data-location">Edit Collateral</h2>
        </div>
        <div class="col-sm-6 col-6 col-md-6 col-lg-6 mt-36">
          <button
            id="collateral-edit-model-close-btn"
            type="button"
            class="close float-end"
            aria-label="Close"
            (click)="hideEditCollateralPopup()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-popup-edit-popup">
        <div class="line-break"></div>
      </div>
      <div class="panel-body mega-cancel-confirmation-model">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-20">
            <p id="collateral-edit-msg">{{ editMessage }}</p>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 mega-type mt-20">
          <span id="collateral-edit-cusip-label">CUSIP</span>
          <div class="dropdown dropdown-menu-width">
            <input
              id="collateral-edit-cusip-input"
              class="edit-popup-enter-details"
              [ngClass]="{
                'add-error-border': showCusipFormatError,
                'remove-error-border': !showCusipFormatError,
              }"
              name="cusip"
              type="text"
              [(ngModel)]="cusipEditInput"
              (change)="editValuechange($event)"
            />
          </div>
          <ng-container *ngIf="showCusipFormatError">
            <ul class="list-group-add-edit">
              <li
                class="analyzer-error-item"
                id="error-item-cusip"
                *ngFor="let error of cusipFormatErrors; trackBy: trackByIdentity"
              >
                <span
                  ><i
                    class="fa fa-exclamation-circle tooltip-error icon-disable error-red dropdown-error"
                  ></i
                ></span>
                {{ error }}
              </li>
            </ul>
          </ng-container>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega-type pl-0 mt-20">
          <span id="collateral-edit-oface-label">Original Face</span>
          <div class="dropdown dropdown-menu-width">
            <input
              id="collateral-edit-oface-input"
              class="edit-popup-enter-details"
              [ngClass]="{
                'add-error-border': showOfaceFormatError,
                'remove-error-border': !showOfaceFormatError,
              }"
              name="oface"
              type="text"
              [(ngModel)]="oFaceEditInput"
              (change)="editValuechange($event)"
            />
          </div>
          <ng-container *ngIf="showOfaceFormatError">
            <ul class="list-group-add-edit">
              <li
                class="analyzer-error-item"
                id="error-item-oface"
                *ngFor="let error of ofaceFormatErrors; trackBy: trackByIdentity"
              >
                <span
                  ><i
                    class="fa fa-exclamation-circle tooltip-error icon-disable error-red dropdown-error"
                  ></i
                ></span>
                {{ error }}
              </li>
            </ul>
          </ng-container>
        </div>
      </div>
      <div class="popup-footer">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 cancel-edit-popup">
          <button
            id="collateral-cancel-edit-btn"
            class="button cancel-edit-collateral-button cancel-edit-button-popup"
            (click)="hideEditCollateralPopup()"
          >
            Cancel Edit
          </button>
          <button
            id="collateral-save-edit-btn"
            class="button edit-collateral-button"
            [disabled]="!showSaveChangeButton"
            (click)="editCollateral()"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="showAddCollateralPopup">
  <div id="collateral-add-popup" class="enter-mega-model-window">
    <div class="panel panel-default fadeInUpBig panel-height-add-edit-modal">
      <div class="row gx-0">
        <div class="col-sm-6 col-6 col-md-6 col-lg-6">
          <h2 id="collateral-add-model-title-msg" class="file-data-location">Add Collateral</h2>
        </div>
        <div class="col-sm-6 col-6 col-md-6 col-lg-6 mt-36">
          <button
            id="collateral-add-model-close-btn"
            type="button"
            class="close float-end"
            aria-label="Close"
            (click)="hideAddCollateralPopup()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-popup-edit-popup">
        <div class="line-break"></div>
      </div>
      <div class="panel-body mega-cancel-confirmation-model">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-20">
            <p id="collateral-add-msg" class="collateral-text-align">{{ addMessage }}</p>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 mega-type mt-20">
          <span id="collateral-add-cusip-label">CUSIP</span>
          <div class="dropdown dropdown-menu-width">
            <input
              id="collateral-add-cusip-input"
              class="edit-popup-enter-details"
              [ngClass]="{
                'add-error-border': showCusipFormatError,
                'remove-error-border': !showCusipFormatError,
              }"
              type="text"
              name="cusip"
              [(ngModel)]="cusipAddInput"
              (change)="addValuechange($event)"
            />
          </div>
          <ng-container *ngIf="showCusipFormatError">
            <ul class="list-group-add-edit">
              <li
                class="analyzer-error-item"
                id="error-item-add-cusip"
                *ngFor="let error of cusipFormatErrors; trackBy: trackByIdentity"
              >
                <span
                  ><i
                    class="fa fa-exclamation-circle tooltip-error icon-disable error-red dropdown-error"
                  ></i
                ></span>
                {{ error }}
              </li>
            </ul>
          </ng-container>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega-type pl-0 mt-20">
          <span id="collateral-add-oface-label">Original Face</span>
          <div class="dropdown dropdown-menu-width">
            <input
              id="collateral-add-oface-input"
              class="edit-popup-enter-details"
              [ngClass]="{
                'add-error-border': showOfaceFormatError,
                'remove-error-border': !showOfaceFormatError,
              }"
              type="text"
              name="oface"
              [(ngModel)]="oFaceAddInput"
              (change)="addValuechange($event)"
            />
          </div>
          <ng-container *ngIf="showOfaceFormatError">
            <ul class="list-group-add-edit">
              <li
                class="analyzer-error-item"
                id="error-item-add-oface"
                *ngFor="let error of ofaceFormatErrors; trackBy: trackByIdentity"
              >
                <span
                  ><i
                    class="fa fa-exclamation-circle tooltip-error icon-disable error-red dropdown-error"
                  ></i
                ></span>
                {{ error }}
              </li>
            </ul>
          </ng-container>
        </div>
        <div class="popup-footer">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 cancel-add-popup">
            <button
              id="collateral-cancel-add-btn"
              class="button fm-secondary-button cancel-add-collateral-button"
              (click)="hideAddCollateralPopup()"
            >
              Cancel
            </button>
            <button
              id="collateral-save-add-btn"
              class="button fm-primary-button add-collateral-button"
              (click)="addCollateral()"
              [disabled]="disableAddCollateralButton"
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="showCreateMegaPopup">
  <div class="create-mega-model-window">
    <div class="panel panel-default fadeInUpBig">
      <div class="row">
        <div class="col-sm-6 col-6 col-md-6 col-lg-6">
          <h2 class="file-data-location">Create Mega/Supers</h2>
        </div>
        <div class="col-sm-6 col-6 col-md-6 col-lg-6 d-flex justify-content-end">
          <button type="button" class="close" aria-label="Close" (click)="hideCreateMegaPopup()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-popup-edit-popup">
          <div class="line-break"></div>
        </div>
      </div>
      <div class="panel-body mega-cancel-confirmation-model">
        <div class="row col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-20">
            <span id="pool-type-label-popup text-size">Pool Type</span><br />
            <ng-container *ngIf="collateralValidatedPoolListRes?.megaType === 'SFFIXMEGA'">
              <span class="fw-bold-and-size" id="pool-type-sff">Single Family Fixed Rate</span>
            </ng-container>
            <ng-container *ngIf="collateralValidatedPoolListRes?.megaType === 'SFARMMEGA'">
              <span class="fw-bold-and-size" id="pool-type-sfa">Single Family ARM</span>
            </ng-container>
            <ng-container *ngIf="collateralValidatedPoolListRes?.megaType === 'MFFIXMEGA'">
              <span class="fw-bold-and-size" id="pool-type-mff">Multi Family Fixed Rate</span>
            </ng-container>
            <ng-container *ngIf="collateralValidatedPoolListRes?.megaType === 'MFARMMEGA'">
              <span class="fw-bold-and-size" id="pool-type-mfa">Multi Family ARM</span>
            </ng-container>
          </div>
          <div class="row col-12 col-sm-12 col-md-6 col-lg-6 mt-20 pl-0 pr-0">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 pl-0 pr-0">
              <span id="prefix-label-popup text-size">Prefix</span><br />
              <span class="fw-bold-and-size" id="prefix-popup">{{
                megaDetailsList?.megaPrefix ? megaDetailsList?.megaPrefix : ''
              }}</span>
            </div>
            <ng-container *ngIf="collateralValidatedPoolListRes?.megaType === 'SFFIXMEGA'">
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 pl-0 pr-0">
                <span id="coupon-label-popup text-size">Coupon</span><br />
                <span class="fw-bold-and-size" id="coupon-popup">{{
                  megaDetailsList?.coupon | number: '1.3-3'
                }}</span>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                collateralValidatedPoolListRes?.megaType === 'SFARMMEGA' ||
                collateralValidatedPoolListRes?.megaType === 'MFARMMEGA'
              "
            >
              <div class="col-12 col-sm-12 col-md-3 col-lg-3 pl-0 pr-0">
                <span id="subtype-label-popup text-size">Subtype</span><br />
                <span class="fw-bold-and-size" id="mega-subtype">{{
                  megaDetailsList?.subType ? megaDetailsList?.subType : ''
                }}</span>
              </div>
            </ng-container>
            <ng-container *ngIf="collateralValidatedPoolListRes?.megaType === 'MFFIXMEGA'">
              <div class="col-12 col-sm-12 col-md-4 col-lg-4 pl-0 pr-0">
                <span id="high-coupon-label-popup text-size">High Coupon</span><br />
                <span class="fw-bold-and-size" id="mega-high-coupon">{{
                  megaDetailsList?.mfHighCoupon | number: '1.3-3'
                }}</span>
              </div>
            </ng-container>
            <ng-container *ngIf="collateralValidatedPoolListRes?.megaType === 'MFFIXMEGA'">
              <div class="col-12 col-sm-12 col-md-4 col-lg-4 pl-0 pr-0">
                <span id="low-coupon-label-popup text-size">Low Coupon</span><br />
                <span class="fw-bold-and-size" id="mega-low-coupon">{{
                  megaDetailsList?.mfLowCoupon | number: '1.3-3'
                }}</span>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-8">
          <span id="pool-amount-label-popup text-size">Pool Amount</span><br />
          <span class="fw-bold-and-size" id="pool-amount-popup">{{
            megaDetailsList?.dealAmount | currency: 'USD' : 'symbol' : '1.2-2'
          }}</span>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-popup-edit-popup">
          <div class="line-break"></div>
        </div>
        <form [formGroup]="collateralAnalyzerForm" (ngSubmit)="getCalculateFee()">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 mega-type mt-16">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 enter-mega-settelment-date">
              <span class="fw-bold" id="enter-settlement-date-label">*Enter Settlement Date</span>
              <div class="input-group-container p__bottom-32">
                <i
                  class="fa fa-calendar calendar-addon"
                  id="sffmCalenderBtn"
                  (click)="dp.openCalendar()"
                ></i>

                <span id="sffmCalenderCtr">
                  <input
                    class="input-calendar"
                    readonly
                    (click)="dp.openCalendar()"
                    (dateChanged)="onDateChanged($event)"
                    placeholder="mm/dd/yyyy"
                    [(ngModel)]="mSfFixDateValue"
                    angular-mydatepicker
                    formControlName="MegaSettlemntDa"
                    [options]="collateralAnalyzerSettlemntDateOptions"
                    #dp="angular-mydatepicker"
                  />
                </span>

                <div class="calender-busy-indicator" *ngIf="showCalendarBusyIndicator">
                  <i class="fa fa-refresh fa-spin fa-3x fa-fw" aria-hidden="true"></i>
                  <span class="loading-calender-text">loading calendar...</span>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-20">
          <p>
            *Megas and Supers must settle at least one business day in the future.If you would like
            <br />
            to settle sooner, please contact Structured Transactions to discuss your options.
          </p>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 remember-selections-block">
            <div class="col-12 col-sm-12 col-md-5 col-lg-5 float-end">
              <button
                class="button fm-tertiary-button"
                aria-label="Close"
                (click)="hideCreateMegaPopup()"
              >
                Cancel
              </button>
              <button
                class="button fm-primary-button"
                type="submit"
                [disabled]="!collateralAnalyzerForm.valid"
                (click)="getCalculateFee()"
              >
                View Fees
              </button>
            </div>
          </div>
        </div>
        <!--div class="visible-xs-12 hidden-md hidden-lg  col-12 col-sm-12 pl-0 remember-selections-block-sm-screen">
          <div class="col-12 col-sm-12 col-md-5 col-lg-5 float-end">
            <button class="button fm-tertiary-button" aria-label="Close" (click)="hideCreateMegaPopup()">Cancel
            </button>
            <button class="button fm-primary-button" type="submit"
                    [disabled]="!collateralAnalyzerForm.valid" (click)="getCalculateFee()">View Fees
            </button>
          </div>
        </div-->
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="displayCancelCollateralPopup">
  <div class="replace-collateral-model-window">
    <div class="panel panel-default fadeInUpBig">
      <div class="row">
        <div class="col-sm-6 col-6 col-md-6 col-lg-6">
          <h2 class="cancel-popup-title" id="cancel-popup-title">
            {{ cancelPopUpTitle }}
          </h2>
        </div>
        <div class="col-sm-6 col-6 col-md-6 col-lg-6 mt-36">
          <button
            type="button"
            class="close float-end"
            aria-label="Close"
            (click)="hideCancelCollateralPopup()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-popup">
          <div class="line-break"></div>
        </div>
      </div>
      <div class="panel-body">
        <div class="row col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
          <div class="col-1 col-sm-1 col-md-1 col-lg-1">
            <i class="fa fa-exclamation-triangle warning-exclamation-icon" id="warning-icon"></i>
          </div>
          <ng-container>
            <div class="col-11 col-sm-11 col-md-11 col-lg-11 pl-0">
              <p id="cancel-upload-info-text-1">{{ cancelUploadCollateralInfoText }}</p>
            </div>
          </ng-container>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-20 ml-20">
          <p id="do-you-proceed-text">Do you wish to proceed?</p>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 footer-block pr-20">
        <div class="float-end pl-0 pr-0">
          <button class="button fm-tertiary-button" (click)="hideCancelCollateralPopup()">
            Cancel
          </button>
          <button
            class="button fm-primary-button"
            (click)="handleReplaceFile()"
            id="yes-replace-button"
          >
            {{ cancelButtonLabel }}
          </button>
        </div>
      </div>
      <!--div class="visible-xs-12 hidden-md hidden-lg  col-12 col-sm-12 pl-0 footer-block-sm-screen pr-20">
        <div class="float-end pl-0 pr-0">
          <button class="button fm-primary-button"
                  (click)="handleReplaceFile()"
                  id="yes-replace-button-sm">{{cancelButtonLabel}}
          </button>
        </div>
      </div-->
    </div>
  </div>
</ng-container>
<ng-container *ngIf="displayDeleteCollateralPopup">
  <div class="replace-collateral-model-window">
    <div class="panel panel-default fadeInUpBig">
      <div class="row">
        <div class="col-sm-6 col-6 col-md-6 col-lg-6">
          <h2 class="cancel-popup-title" id="delete-popup-title">Delete Collateral</h2>
        </div>
        <div class="col-sm-6 col-6 col-md-6 col-lg-6 mt-36">
          <button
            type="button"
            class="close float-end"
            id="collateral-delete-model-close-btn"
            aria-label="Close"
            (click)="hideDeleteCollateralPopup()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-popup">
          <div class="line-break"></div>
        </div>
      </div>
      <div class="panel-body">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
          <ng-container>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
              <p id="cancel-upload-info-text-1" class="collateral-text-align">
                {{ deleteCollateralInfoText }}
              </p>
            </div>
          </ng-container>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 delete-confirm-text-place">
          <span class="delete-confirm-text text-size" id="do-you-proceed-text"
            >Do you wish to proceed?</span
          >
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 remember-selections-block">
          <div class="popup-footer">
            <div class="col-12 col-sm-12 col-md-8 col-lg-8 delete-popup-save-changes">
              <button
                class="button fm-tertiary-button"
                id="collateral-delete-cancel-btn"
                (click)="hideDeleteCollateralPopup()"
              >
                Cancel
              </button>
              <button
                class="button fm-primary-button"
                id="collateral-delete-yes-btn"
                (click)="handleDeleteSelected()"
              >
                Yes Delete
              </button>
            </div>
          </div>
        </div>
        <!--div class="visible-xs-12 hidden-md hidden-lg  col-12 col-sm-12 pl-0 remember-selections-block-sm-screen">
          <div class="popup-footer">
            <div class="col-12 col-sm-12 col-md-8 col-lg-8 delete-popup-save-changes">
              <button class="button fm-tertiary-button" (click)="hideDeleteCollateralPopup()">Cancel
              </button>
              <button class="button fm-primary-button" (click)="handleDeleteSelected()">Yes Delete</button>
            </div>
          </div>
        </div-->
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="displayDeleteAllCollateralPopup">
  <div class="replace-collateral-model-window">
    <div class="panel panel-default fadeInUpBig">
      <div class="row">
        <div class="col-sm-6 col-6 col-md-6 col-lg-6">
          <h2 class="cancel-popup-title" id="delete-all-popup-title">Delete All Collateral</h2>
        </div>
        <div class="col-sm-6 col-6 col-md-6 col-lg-6 mt-36">
          <button
            type="button"
            class="close float-end"
            id="collateral-delete-all-model-close-btn"
            aria-label="Close"
            (click)="hideDeleteAllCollateralPopup()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-popup">
          <div class="line-break"></div>
        </div>
      </div>
      <div class="panel-body">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
          <ng-container>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
              <p id="cancel-upload-info-text-2" class="collateral-text-align">
                {{ deleteAllCollateralInfoText }}
              </p>
            </div>
          </ng-container>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 delete-confirm-text-place">
          <span class="delete-confirm-text">Do you wish to proceed?</span>
        </div>
        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 hidden-xs hidden-sm pl-0 remember-selections-block"
        >
          <div class="popup-footer">
            <div class="col-12 col-sm-12 col-md-8 col-lg-8 delete-popup-save-changes">
              <button
                class="button fm-tertiary-button"
                id="collateral-delete-all-cancel-btn"
                (click)="hideDeleteAllCollateralPopup()"
              >
                Cancel
              </button>
              <button
                class="button fm-primary-button"
                id="collateral-delete-all-yes-btn"
                (click)="handleDeleteAll()"
              >
                Yes Delete
              </button>
            </div>
          </div>
        </div>
        <div
          class="visible-xs-12 hidden-md hidden-lg col-12 col-sm-12 pl-0 remember-selections-block-sm-screen"
        >
          <div class="popup-footer">
            <div class="col-12 col-sm-12 col-md-8 col-lg-8 delete-popup-save-changes">
              <button class="button fm-tertiary-button" (click)="hideDeleteAllCollateralPopup()">
                Cancel
              </button>
              <button class="button fm-primary-button" (click)="handleDeleteAll()">
                Yes Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="showIEAnalyzerPopUp">
  <div class="IE-message-model-window">
    <div class="panel panel-default fadeInUpBig">
      <div class="row">
        <div class="col-sm-6 col-6 col-md-6 col-lg-6">
          <h2 class="cancel-popup-title" id="cancel-popup-title">Message</h2>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-popup-IE">
          <div class="line-break"></div>
        </div>
      </div>
      <div class="panel-body">
        <div class="row col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
          <div class="col-1 col-sm-1 col-md-1 col-lg-1 exclamation-pos">
            <i class="fa fa-exclamation-triangle warning-exclamation-icon" id="warning-icon"></i>
          </div>
          <div class="col-12 col-sm-12 col-md-11 col-lg-11 IEmessage">
            <p id="do-you-proceed-text">
              This feature is not compatible with IE. Please use another browser if possible
              (Microsoft Edge, Google Chrome, Mozilla Firefox, etc.)
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 hidden-xs hidden-sm pl-0 footer-block pr-20">
        <div class="float-end pl-0 pr-0">
          <button class="button fm-tertiary-button" (click)="navigateToHome()">Home</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<div class="warning-modal-window" *ngIf="showFreddieIssuedAmtWarning">
  <div class="panel panel-default fadeInUpBig">
    <div class="panel-body">
      <p>
        The associated trade contains over 50% Freddie Mac collateral. Please note that continuing
        may result in a higher commingling fee than you anticipated.<br />
      </p>
      <h4>Do you wish to proceed?</h4>
      <br />
      <button class="button fm-tertiary-button" (click)="cancelMegaCreation()">NO</button>
      <button
        class="button fm-primary-button"
        (click)="continueMegaCreation(collateralValidatedPoolListRes?.megaType)"
      >
        YES
      </button>
    </div>
  </div>
</div>
